import * as React from "react";
import { Box, IconButton, List, ListItemButton, ListItemText, Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

export default function ChatHistoryView({ chats, activeChatUid, onSelectChat, onRequestDelete }) {
    if (chats.length === 0) {
        return (
            <Typography color="text.secondary" sx={{ p: 3, textAlign: "center" }}>
                No chats yet. Ask a question to start one.
            </Typography>
        );
    }

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>Chats</Typography>
            <List disablePadding>
                {chats.map((chat) => (
                    <ListItemButton
                        key={chat.ai_assistant_chat_uid}
                        selected={chat.ai_assistant_chat_uid === activeChatUid}
                        onClick={() => onSelectChat(chat)}
                        sx={{ borderRadius: 1, pr: 1 }}
                    >
                        <ListItemText primary={chat.title || "New chat"} primaryTypographyProps={{ noWrap: true }} />
                        <IconButton
                            size="small"
                            aria-label="Delete chat"
                            onClick={(event) => {
                                event.stopPropagation();
                                onRequestDelete(chat);
                            }}
                        >
                            <DeleteOutlineIcon fontSize="small" />
                        </IconButton>
                    </ListItemButton>
                ))}
            </List>
        </Box>
    );
}
